<style scoped lang="less">
.layout{width: 424px;height: auto;background: rgba(34, 85, 172, 0.88);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;transform: translate(-50%, -50%);border: 1px solid #6491e0;border-radius: 6px;}
.title{height: 35px;background-color: #2080ff;margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";color: #fff;}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #fff;text-align: center;}
/deep/.el-form-item {margin: 15px;}
/deep/.el-input__inner {color: #000;}
.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}
.el-button {border-radius: 4px;border: solid 1px #2080ff;}
.el-button--primary {color: #FFF;background-color: #2080ff;}
.el-button--default {color: #FFF;background: #2080ff;}
/deep/.el-input__inner{ background-color: transparent !important; border: solid 1px #7ae9ff;border-radius: 5px;color: #fff;}
/deep/.el-tabs__nav{padding: 0px !important;width: 100%;text-align: center;}
/deep/.el-tabs__item {width: 50%;font-size: 14px;color: #FFF;padding: 0;}
/deep/.el-tabs__item.is-active {color: #7ae9ff;}
/deep/.el-tabs__active-bar {color: #7ae9ff;}
/deep/.el-tab-pane {height: 345px;}
/deep/.el-tab-pane .el-form {height: 100%;display: flex;flex-direction: column;justify-content: space-around;}
/deep/.popup-content-type {height: 340px;}
/deep/.popup-content-type .el-form {height: 100%;display: flex;flex-direction: column;justify-content: space-around;}
/deep/.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;background: rgba(10, 17, 43, 0.4);border:none!important;box-shadow:0 0 0 0}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}

</style>

<template>
<div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>标注</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="点击地图" name="first">
          <el-form ref="form" :model="form" label-width="90px">
            <el-form-item label="标注：">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="图标：">
              <el-radio-group v-model="form.radio" class="markbox">
                   <el-radio-button :label="index" v-for="(item, index) in imglist" :key="index">
                    <img :src="item" alt="">
                  </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="输入坐标" name="second">
          <el-form ref="form2" :model="form2" label-width="90px">
            <el-form-item label="标注：">
              <el-input v-model="form2.name"></el-input>
            </el-form-item>
            <el-form-item label="经度：">
              <el-input v-model="form2.longitude"></el-input>
            </el-form-item>
            <el-form-item label="纬度：">
              <el-input v-model="form2.latitude"></el-input>
            </el-form-item>
            <el-form-item label="图标：">
              <el-radio-group v-model="form2.radio" class="markbox">
                   <el-radio-button :label="index" v-for="(item, index) in imglist" :key="index">
                    <img :src="item" alt="">
                  </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cancels">取消</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
let point
let pointLabel
export default {
  data()
  {
    return {
      flag: false,
      activeName: 'first',
      imglist: [
        'static/index/map-marker1.png',
        'static/index/map-marker2.png',
        'static/index/map-marker3.png',
        'static/index/map-marker4.png',
        'static/index/map-marker5.png'
      ],
      form: {
        name: '',
        radio: '0'
      },
      form2: {
        name: '',
        longitude: '',
        latitude: '',
        radio: '0'
      },
      LayernarData: [],
      drawMeasure: null,
      layerMeasure: null,
      depthTestAgainstTerrain: true
    }
  },
  methods: {
    showLP()
    {
      // this.form.radio = '0'
      if (this.flag)
        this.flag = false
      else
        this.flag = true
    },
    closePul(show)
    {
      this.flag = show
      this.form = {}
      this.forms = {}
      // 去除画的点
      let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
      this.cancel()
      layer.removeOverlay(point)
      layer.removeOverlay(pointLabel)
    },
    closeBox(show)
    {
      this.flag = show
      this.form = {}
      this.forms = {}
    },
    onSubmit()
    {
      if (this.activeName === 'first')
      {
        if (this.form.name)
          this.drawPoint(this.form)
        else
          this.$message({message: '请先输入标注信息', type: 'warning', customClass: 'mzindex'})
      }
      else if (this.activeName === 'second')
      {
        if (this.form2.name && this.form2.longitude && this.form2.latitude)
          this.clickMark(this.form2)
        else
          this.$message({message: '请先输入坐标以及标注信息', type: 'warning', customClass: 'mzindex'})
      }
    },
    // 输入坐标点击添加
    clickMark(val)
    {
      let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
      point && layer.removeOverlay(point)
      pointLabel && layer.removeOverlay(pointLabel)
      // 添加广告牌
      point = new window.cxe.Billboard({lng: val.longitude, lat: val.latitude, alt: 5000}, this.imglist[val.radio])
      point.size = [30, 30]

      // 添加注记
      pointLabel = new window.cxe.Label({ lng: val.longitude, lat: val.latitude, alt: 5000 }, val.name)
      pointLabel.setStyle({
        heightReference: window.Cesium.HeightReference.NONE,
        showBackground: true,
        pixelOffset: new window.Cesium.Cartesian2(0, 20),
        fillColor: window.Cesium.Color.AZURE,
        backgroundColor: new window.Cesium.Color(0, 0, 0, 0.7),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        font: '16px sans-serif',
        eyeOffset: new window.Cesium.Cartesian3(0, 0, 0)
      })
      layer.addOverlay(point)
      layer.addOverlay(pointLabel)
      // Viewer.flyTo(point)
      Viewer.camera.flyTo({
        destination: window.Cesium.Cartesian3.fromDegrees(val.longitude, val.latitude, 1485110),
        duration: 4
      })
    },
    // 画点
    drawPoint(val)
    {
      val.radio = this.imglist[val.radio]
      this.$emit('drawPoint', val)
    },
    cancel()
    {
      this.form = {}
      this.$emit('delPoint')
    },
    cancels()
    {
      this.clear()
      let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
      if (point)
      {
        layer.removeOverlay(point)
        layer.removeOverlay(pointLabel)
      }
      this.form2 = {}
    },
    // 点击切换tab
    handleClick(val)
    {
      if (val.name === 'first')
        this.form2 = {}
      else
        this.form = {}
    },
    clear()
    {
      this.LayernarData.forEach(e =>
      {
        e.getSource().clear()
        window.map.removeLayer(e)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/LabelPoint.vue